export enum AP3UserManagementRouteNames {
  AP3_USERS_ROOT = 'AP3UsersRoot',
  AP3_USERS = 'AP3UsersRoot/Users',
  AP3_USERS_LIST = 'AP3UsersRoot/Users/List',
  AP3_USERS_CREATE = 'AP3UsersRoot/Users/Create',
  AP3_USERS_DETAILS = 'AP3UsersRoot/Users/Details',
}
